import { Input } from '@pulse-web-ui/input';
import { styled } from '@pulse-web-ui/theme';

export const PromoCodeInput = styled(Input)`
  & + label {
    top: ${({ value }) => (value?.length ? '7px' : '17px')};
  }
`;
